import React from "react";
import { Modal } from "antd";

import DocumentPreview from "../../../../../NewComponents/DocumentPreview/DocumentPreview";
import { Close, Download, FileText } from "../../FundForm/icons";
import styles from "../previewFund.module.scss";

interface ITermSheetPreviewModal {
  open: boolean;
  url: string;
  fileName: string;
  mimeType: string;
  onDownload: () => void;
  onClose: () => void;
}

/** The type tag beside the title: "PDF", "JPEG", "DOCX". */
const extensionOf = (fileName: string) =>
  fileName.includes(".") ? fileName.split(".").pop()?.toUpperCase() : undefined;

/**
 * The term sheet, read in place.
 *
 * Download stays in the header, so having looked at it is one click from
 * keeping it. The document itself is drawn by the app's shared viewer.
 */
export default function TermSheetPreviewModal({
  open,
  url,
  fileName,
  mimeType,
  onDownload,
  onClose,
}: ITermSheetPreviewModal) {
  const extension = extensionOf(fileName);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={1040}
      centered
      destroyOnClose
      styles={{ content: { padding: 0, overflow: "hidden", borderRadius: 12 } }}
      aria-labelledby="term-sheet-preview-title"
    >
      <header className={styles.viewerHead}>
        <div className={styles.file}>
          <div className={styles.fileIcon}>
            <FileText size={18} color="#713fff" />
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <h2 id="term-sheet-preview-title" className={styles.viewerTitle}>
                Term sheet
              </h2>
              {extension ? (
                <span className={styles.viewerType}>{extension}</span>
              ) : null}
            </div>
            <div className={styles.rowCopy} title={fileName}>
              <span className={styles.fileName} style={{ fontSize: 13 }}>
                {fileName}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.buttons} style={{ flexWrap: "nowrap" }}>
          <button
            type="button"
            className={styles.buttonOutline}
            onClick={onDownload}
          >
            <Download />
            Download
          </button>
          <button
            type="button"
            className={styles.iconButton}
            aria-label="Close preview"
            onClick={onClose}
          >
            <Close />
          </button>
        </div>
      </header>

      <div className={styles.viewerBody}>
        <DocumentPreview
          url={url}
          mimeType={mimeType}
          width="100%"
          height="100%"
          pageWidth={860}
        />
      </div>
    </Modal>
  );
}
